
export class TeamInviteModel {

    constructor(
      public id: string,
      public title: string,
      public email: string
    ) {  }
  }
  